import { useQuery, useQueryClient } from "@tanstack/react-query";
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

export const useRatios = ({ year, yearMonth, enabled = true }) => {
	return useQuery({
		queryKey: ["ratios", { year, yearMonth }],
		queryFn: async () => {
			const getRatios = httpsCallable(functions, "getRatiosFunction");
			const result = await getRatios({ year, yearMonth });
			return result.data;
		},
		enabled,
		staleTime: 5 * 60 * 1000, // 5 minutes
		cacheTime: 30 * 60 * 1000, // 30 minutes
		refetchOnWindowFocus: false,
	});
};

// Hook to invalidate the ratio cache
export const useInvalidateRatios = () => {
	const queryClient = useQueryClient();

	return {
		invalidateAll: () => {
			queryClient.invalidateQueries({ queryKey: ["ratios"] });
		},
		invalidateYear: year => {
			queryClient.invalidateQueries({
				queryKey: ["ratios"],
				predicate: query => query.queryKey[1]?.year === year,
			});
		},
		invalidateMonth: yearMonth => {
			queryClient.invalidateQueries({
				queryKey: ["ratios"],
				predicate: query => query.queryKey[1]?.yearMonth === yearMonth,
			});
		},
	};
};
